import React from "react";

const svgPath = (name) => `${process.env.PUBLIC_URL}/style-svgs/${name}.svg`;

const Deco = ({ name, className = "" }) => (
  <img
    className={`site-deco ${className}`}
    src={svgPath(name)}
    alt=""
    aria-hidden="true"
  />
);

export default Deco;
